/* Arando AB-Tool - Asset JS (Production)
 * Loaded via {{ 'aab.js' | asset_url }} from snippets/aab.liquid.
 *
 * WP7 (14.06.) hot-path:
 *   - The page is pre-hidden ONLY on a matched test path (done in the liquid
 *     wrapper), so non-test pages have zero render impact.
 *   - The bucket is cached in a cookie. REPEAT visitors act instantly with NO
 *     network round-trip and NO second beacon (already counted). Only the very
 *     first visit on a test path calls the server.
 *   - Bucketing stays server-side (/api/ab/decision returns bucket + a signed
 *     beacon token); the seed is never exposed to the client.
 */
(function () {
  'use strict';

  var API_BASE = 'https://analytics.arando.online/api/ab';
  var API_EV = 'https://analytics.arando.online/c/ev';
  var DECISION_TIMEOUT_MS = 2000;

  function getCookie(n) {
    var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + n + '=([^;]+)'));
    return m ? decodeURIComponent(m[1]) : null;
  }

  function cookieDomain() {
    // Host-aware so the vid persists on whichever Markets domain the visitor entered
    // through (a FB ad to arando-online.com must stay on .com). .de keeps the parent
    // domain so the id is shared across the shop AND the funnel (angebot.*) for #17;
    // .com gets its own parent domain; anything else is host-only.
    var h = window.location.hostname;
    if (/(^|\.)arando-online\.de$/i.test(h)) return ';domain=.arando-online.de';
    if (/(^|\.)arando-online\.com$/i.test(h)) return ';domain=.arando-online.com';
    return '';
  }

  function setCookie(n, v, d) {
    var dt = new Date();
    dt.setTime(dt.getTime() + d * 86400000);
    document.cookie = n + '=' + encodeURIComponent(v) +
      ';expires=' + dt.toUTCString() + ';path=/' + cookieDomain() + ';SameSite=Lax';
  }

  function uuid4() {
    var c = window.crypto;
    if (c && c.getRandomValues) {
      var a = new Uint8Array(16);
      c.getRandomValues(a);
      a[6] = (a[6] & 0x0f) | 0x40;
      a[8] = (a[8] & 0x3f) | 0x80;
      var h = [];
      for (var i = 0; i < 16; i++) h.push((a[i] + 0x100).toString(16).slice(1));
      return h.slice(0, 4).join('') + '-' + h.slice(4, 6).join('') + '-' +
             h.slice(6, 8).join('') + '-' + h.slice(8, 10).join('') + '-' +
             h.slice(10, 16).join('');
    }
    return 'fb-' + Date.now() + '-' + Math.random().toString(16).slice(2);
  }

  function unhide() {
    var hideEl = document.getElementById('aab-hide');
    if (hideEl && hideEl.parentNode) hideEl.parentNode.removeChild(hideEl);
  }

  function normPath(p) {
    return p.replace(/\/+$/, '') || '/';
  }

  function matchedTest(tests) {
    var host = window.location.host;
    var pathname = normPath(window.location.pathname);
    for (var i = 0; i < tests.length; i++) {
      var t = tests[i];
      var aUrl;
      try { aUrl = new URL(t.url_a); } catch (e) { continue; }
      // host-aware: a funnel test must not trigger on a same-path Shopify page.
      if (aUrl.host === host && pathname === normPath(aUrl.pathname)) return t;
    }
    return null;
  }

  function addUtmParams(url) {
    var p = new URLSearchParams(window.location.search);
    var map = { utm_source: 'us', utm_medium: 'um', utm_campaign: 'uc', utm_content: 'ucnt', utm_term: 'ut' };
    for (var k in map) {
      var v = p.get(k);
      if (v) url.searchParams.set(map[k], v);
    }
  }

  function sendVisit(testId, vid, bucket, token, isNew) {
    var beacon = new URL(API_BASE + '/visit');
    beacon.searchParams.set('t', testId);
    beacon.searchParams.set('v', vid);
    beacon.searchParams.set('b', bucket);
    if (token) beacon.searchParams.set('s', token);
    // segmentation dims (diagnostic): market from Shopify localization, new-visitor flag
    var ctx = window.__AAB_CTX__ || {};
    if (ctx.c) beacon.searchParams.set('c', ctx.c);
    if (ctx.l) beacon.searchParams.set('l', ctx.l);
    if (isNew !== undefined) beacon.searchParams.set('n', isNew ? '1' : '0');
    addUtmParams(beacon);
    var url = beacon.toString();
    if (navigator.sendBeacon) navigator.sendBeacon(url);
    else new Image().src = url;
  }

  // Slug = letztes url_a-Pfadsegment, lowercase (identisch zur Worker-/Dashboard-Logik).
  function evSlug(urlA) {
    try {
      var p = new URL(urlA).pathname.replace(/\/+$/, '');
      return (p.split('/').filter(Boolean).pop() || '').toLowerCase();
    } catch (e) { return ''; }
  }

  // Gegenpruefung: unabhaengiges First-Party Besucher-Beacon (event_visits /c/ev),
  // getrennt von der AAB-Visit-Pipeline. GET (public, wie der /imp-Pixel) damit kein
  // Token im Client liegt; keepalive, damit es den Bucket-B-Redirect ueberlebt. Sendet
  // die vid mit -> COUNT(DISTINCT vid) = eindeutige Besucher wie bei AAB. Feuert NUR mit
  // echtem Bucket (nicht im QA-Force-Pfad).
  function countPageview(test, bucket, vid) {
    try {
      var slug = test && test.url_a ? evSlug(test.url_a) : '';
      if (!slug || !vid) return;
      var u = API_EV + '?d=' + encodeURIComponent(window.location.hostname) +
        '&p=' + encodeURIComponent(slug) +
        ((bucket === 'A' || bucket === 'B') ? '&b=' + bucket : '') +
        '&vid=' + encodeURIComponent(vid);
      if (window.fetch) {
        fetch(u, { method: 'GET', keepalive: true, mode: 'no-cors', cache: 'no-store' }).catch(function () {});
      } else {
        new Image().src = u;
      }
    } catch (e) {}
  }

  // Reveal the page, or for a B-bucket visitor redirect to the variant URL.
  function applyBucket(test, bucket) {
    if (bucket === 'B' && test.redirect_enabled !== false) {
      var dest;
      try { dest = new URL(test.url_b); } catch (e) { unhide(); return; }
      var sameHost = dest.host === window.location.host;
      var onDest = sameHost && normPath(dest.pathname) === normPath(window.location.pathname);
      if (!onDest) {
        // Merge url_b's eigene Query mit der aktuellen (UTMs etc.).
        var cur = window.location.search ? window.location.search.slice(1) : '';
        var params = dest.search ? dest.search.slice(1) : '';
        if (cur) params = params ? params + '&' + cur : cur;
        if (!sameHost) {
          // cross-domain (z.B. Shopify -> angebot.* Funnel): vid mitgeben, Cookies koennen
          // Registrable-Domains nicht ueberqueren (analog zum /go-Worker fuer das Offer).
          var xvid = getCookie('aab_vid');
          if (xvid && params.indexOf('aab_vid=') === -1) params = (params ? params + '&' : '') + 'aab_vid=' + encodeURIComponent(xvid);
        }
        var qs = params ? '?' + params : '';
        var target = (sameHost ? dest.pathname : (dest.origin + dest.pathname)) + qs + window.location.hash;
        window.location.replace(target);
        return;
      }
    }
    unhide();
  }

  var UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

  // Cross-domain vid handoff: a foreign-domain funnel (e.g. the dentalcare-guide.info
  // advertorial) records its AAB visit under our vid and carries that vid in the CTA
  // URL (?aab_vid=). Cookies can't cross registrable domains, so we adopt the carried
  // vid into the .arando-online.de cookie HERE, before the Customer-Events pixel reads
  // it, so the order carries the same vid and the multi-test webhook credits the
  // foreign test. Runs independently of matchedTest (the landing page is not itself a
  // url_a). No-op on normal pages: only ever fires when ?aab_vid is a valid UUID, and
  // only the cross-domain /go worker ever appends that param.
  function adoptCrossDomainVid() {
    try {
      var carried = new URLSearchParams(window.location.search).get('aab_vid');
      if (carried && UUID_RE.test(carried) && getCookie('aab_vid') !== carried) {
        setCookie('aab_vid', carried, 180);
      }
    } catch (e) {}
  }

  // DETERMINISTIC order attribution: write the visitor id into the Shopify CART
  // attributes from the REAL storefront context. Shopify forwards cart attributes ->
  // order note_attributes, which the orders/paid webhook reads. STAND 21.06.: der
  // Cart-Stamp (+ offer-checkout-interceptor fuer /cart/..?checkout-Permalinks) ist der
  // PRIMAERE Attributionspfad; die checkout-token-Bridge (Customer-Events-Pixel) ist
  // stillgelegt (Pixel geloescht, Code als Notnagel vorhanden). Zusaetzlich _aab_tb: die
  // pro-Test-Bucket-Liste aus den aab_b_*-Cookies, damit die Order ihre Zuordnung selbst
  // traegt (unabhaengig vom aab_visits-Re-Join). keepalive, damit der Write den B-Redirect
  // ueberlebt.
  // Pro-Test-Bucket-Liste aus den aab_b_<id>-Cookies, kompakt "15:B,16:A".
  function collectBuckets() {
    var out = [], all = document.cookie.split(';');
    for (var i = 0; i < all.length; i++) {
      var m = all[i].match(/(?:^|\s)aab_b_(\d+)=([AB])\b/);
      if (m) out.push(m[1] + ':' + m[2]);
    }
    return out.join(',');
  }
  var _cartStamped = false; // once per page-load; re-stampt bei jeder Navigation, damit ein
                            // beim Add-to-Cart neu erzeugter Cart die Attribute behaelt.
  function ensureCartVid(vid) {
    try {
      if (!vid || !UUID_RE.test(vid) || _cartStamped) return;
      _cartStamped = true;
      var attrs = { _aab_vid: vid };
      var tb = collectBuckets();
      if (tb) attrs._aab_tb = tb;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs }),
        keepalive: true,
        credentials: 'same-origin'
      }).catch(function () {});
    } catch (e) {}
  }

  // Nach der Bucket-Entscheidung erneut stampen: der Erst-Stamp (run(), vor der
  // Entscheidung) trug nur _aab_vid, weil das aab_b_<id>-Cookie da noch nicht existierte.
  // Der Kontroll-Arm (Bucket A, KEIN Redirect) bekam sonst auf dem Erstbesuch NIE _aab_tb
  // in den Cart -> Control-Orders ohne Test-Zuordnung (Bug #26-A, 18.07.). Guard zuruecksetzen,
  // damit dieser zweite /cart/update.js-Write durchgeht (merge-Semantik: _aab_tb kommt dazu,
  // _aab_vid bleibt). keepalive im ensureCartVid ueberlebt den B-Redirect.
  function stampCartWithBucket(vid) {
    _cartStamped = false;
    ensureCartVid(vid);
  }

  // Bucketing-Hash, byte-genau identisch zu app.py (_mul32 / _mmh3_32 / _bucket_for_vid),
  // damit die client-seitige Entscheidung exakt den Bucket liefert, den der Server vergeben
  // haette (Kontinuitaet mit bestehenden Cookies + Server-Re-Derivation am Visit-Beacon).
  function mul32(a, b) { return Math.imul(a >>> 0, b >>> 0) >>> 0; }
  function mmh3_32(key, seed) {
    var data = new TextEncoder().encode(key);
    var length = data.length, h1 = seed >>> 0;
    var c1 = 0xcc9e2d51, c2 = 0x1b873593, rounded = length & ~3, i, k1;
    for (i = 0; i < rounded; i += 4) {
      k1 = (data[i] | (data[i + 1] << 8) | (data[i + 2] << 16) | (data[i + 3] << 24)) >>> 0;
      k1 = mul32(k1, c1);
      k1 = ((k1 << 15) | (k1 >>> 17)) >>> 0;
      k1 = mul32(k1, c2);
      h1 = (h1 ^ k1) >>> 0;
      h1 = ((h1 << 13) | (h1 >>> 19)) >>> 0;
      h1 = (mul32(h1, 5) + 0xe6546b64) >>> 0;
    }
    k1 = 0;
    var tail = length & 3;
    if (tail === 3) k1 = (k1 ^ (data[rounded + 2] << 16)) >>> 0;
    if (tail >= 2) k1 = (k1 ^ (data[rounded + 1] << 8)) >>> 0;
    if (tail >= 1) {
      k1 = (k1 ^ data[rounded]) >>> 0;
      k1 = mul32(k1, c1);
      k1 = ((k1 << 15) | (k1 >>> 17)) >>> 0;
      k1 = mul32(k1, c2);
      h1 = (h1 ^ k1) >>> 0;
    }
    h1 = (h1 ^ length) >>> 0;
    h1 = (h1 ^ (h1 >>> 16)) >>> 0;
    h1 = mul32(h1, 0x85ebca6b);
    h1 = (h1 ^ (h1 >>> 13)) >>> 0;
    h1 = mul32(h1, 0xc2b2ae35);
    h1 = (h1 ^ (h1 >>> 16)) >>> 0;
    return h1 >>> 0;
  }
  function bucketForVid(testId, vid, split, seed) {
    return (mmh3_32(testId + ':' + vid, seed) % 100) < split ? 'B' : 'A';
  }

  function run() {
    adoptCrossDomainVid();
    // Stamp any existing vid onto the cart on EVERY page (covers offer/variant pages
    // and cross-domain arrivals, which are not themselves a test url_a).
    var existingVid = getCookie('aab_vid');

    var tests = window.__AAB_TESTS__ || [];
    var test = matchedTest(tests);
    // Nicht-Test-Seite: bestehende vid EINMALIG stampen (offer/variant/cross-domain).
    // Auf Test-Seiten hier NICHT stampen -> stampCartWithBucket() weiter unten macht den
    // EINZIGEN, autoritativen Cart-Write NACH der Bucket-Entscheidung. Zwei parallele
    // /cart/update.js-Writes (vid-only + vid+tb) racen sonst auf demselben Cart und
    // verlieren _aab_tb per Lost-Update -> Kontroll-Arm stampt nur sporadisch (19.07.).
    if (!test) { if (existingVid) ensureCartVid(existingVid); unhide(); return; }

    // QA preview: ?aab_force=A|B lets an operator deterministically land on a variant
    // (and trigger the B redirect) on the LIVE test path WITHOUT polluting the data
    // (no /decision call, no visit beacon). Cached in a SEPARATE qa cookie (aab_qa_<id>)
    // that the real path NEVER reads, so a QA session can't contaminate a later real
    // visit's bucket on the same browser.
    var forced = (new URLSearchParams(window.location.search).get('aab_force') || getCookie('aab_qa_' + test.id) || '').toUpperCase();
    if (forced === 'A' || forced === 'B') {
      setCookie('aab_qa_' + test.id, forced, 1);
      applyBucket(test, forced);
      return;
    }

    var vid = getCookie('aab_vid');
    var isNew = !vid;  // brand-new store visitor iff we have to mint the id now
    if (!vid) { vid = uuid4(); setCookie('aab_vid', vid, 180); }  // Stamp erst nach Bucket-Entscheidung (ein Write, kein Race)

    // Repeat visitor: bucket already assigned + recorded -> act instantly.
    var cached = getCookie('aab_b_' + test.id);
    if (cached === 'A' || cached === 'B') { stampCartWithBucket(vid); countPageview(test, cached, vid); applyBucket(test, cached); return; }

    // First visit: decide the bucket INSTANTLY client-side when the metafield carries
    // seed+split (no /decision round-trip, no hidden-page wait). Same mmh3 as the server,
    // so the vid gets the identical bucket the server would have assigned. The async visit
    // beacon carries no token; the server re-derives + validates it. Falls back to the
    // server /decision below if seed/split are absent (metafield not yet re-synced).
    if (typeof test.seed === 'number' && typeof test.split_pct_b === 'number') {
      try {
        var localBucket = bucketForVid(test.id, vid, test.split_pct_b, test.seed);
        setCookie('aab_b_' + test.id, localBucket, 180);
        stampCartWithBucket(vid);  // jetzt ist aab_b_<id> gesetzt -> _aab_tb landet im Cart (auch Control)
        sendVisit(test.id, vid, localBucket, null, isNew);
        countPageview(test, localBucket, vid);
        applyBucket(test, localBucket);
        return;
      } catch (e) { /* TextEncoder/Hash nicht verfuegbar -> Fallback auf /decision unten */ }
    }

    // First visit on this test path: get the server-side bucket + signed token,
    // bounded by a timeout so a slow/down backend can't hang the hero (the 800ms
    // inline failsafe reveals the page either way).
    var decisionUrl = new URL(API_BASE + '/decision');
    decisionUrl.searchParams.set('t', test.id);
    decisionUrl.searchParams.set('v', vid);
    var ctrl = ('AbortController' in window) ? new AbortController() : null;
    var timer = ctrl ? window.setTimeout(function () { ctrl.abort(); }, DECISION_TIMEOUT_MS) : null;

    fetch(decisionUrl.toString(), { method: 'GET', credentials: 'omit', cache: 'no-store', signal: ctrl ? ctrl.signal : undefined })
      .then(function (res) {
        if (res.status === 204) return null;
        if (!res.ok) throw new Error('decision failed: ' + res.status);
        return res.json();
      })
      .then(function (decision) {
        if (timer) window.clearTimeout(timer);
        if (!decision) { unhide(); return; }
        setCookie('aab_b_' + test.id, decision.bucket, 180);
        stampCartWithBucket(vid);  // Bucket steht -> _aab_tb in den Cart (auch Control, Erstbesuch)
        sendVisit(decision.test_id, vid, decision.bucket, decision.token, isNew);
        countPageview(test, decision.bucket, vid);
        applyBucket(test, decision.bucket);
      })
      .catch(function (e) {
        if (timer) window.clearTimeout(timer);
        if (window.console && console.warn) console.warn('aab', e);
        unhide();
      });
  }

  try {
    run();
  } catch (e) {
    if (window.console && console.warn) console.warn('aab', e);
    unhide();
  }
})();
